/* eslint-disable react/no-did-update-set-state */
/* eslint-disable no-await-in-loop */
/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import moment from 'utils/moment';
import { INSPECTIONS } from '../../../constants/RouterConstants';
import {
  clearInspection,
  completeInspection,
  createRemark,
  editRemark,
  remove_remark,
  deleteRemark,
  fetchDraftInspection,
  fetchDataSourceList,
  fetchPortalInspection,
  getChecklistAttachments,
  fetchShiftTypes
} from '../redux/actions';

import SectionHeader from '../../../components/sectionHeader';
import Button from '../../../components/button';
import HeaderBack from '../../../components/headerBack';
import InspectionDetails from './components/InspectionDetails/InspectionDetails';
import InspectionChecklist from './components/InspectionChecklist/InspectionChecklist';
import InspectionSubmitted from './components/InspectionSubmitted/InspectionSubmitted';
import { checkChecklistCondition } from '../InspectionUtils';
import { importAllImages } from '../../../utils/helpers';
import styles from './inspection.module.scss';
import Modal from '../../../components/modal';
import Loading from '../../../components/loading/loading';
import { GetFileName, S3Uploads } from '../../services';
import CompletionModal from './components/CompletionModal';

class CompleteInspection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stage: 1,
      apiStatus: undefined,
      showFormErrors: false,
      answers: {
        date: moment().format(),
        tags: []
      },
      remarks: [],
      activeInspectionField: 0,
      requiredMap: {},
      fieldErrors: {},
      incompleteChecklist: false,
      start_date: undefined,
      end_date: undefined,
      showDateerror: false,
      inspection: {
        info: {
          name: '',
          icon: ''
        },
        details: {
          fields: [],
          additionalInfo: ''
        },
        checklist: []
      },
      showModal: false,
      showErrorModal: false,
      inspection_type: '',
      loadingStatus: false,
      shiftTypes: [],
      unsatisfactoryError: false,
      DateChanged: false,
      open_workorders: {},
      draftLoading: false,
      initialRender: true,
      showStartEndModel: false,
      shiftSetting: undefined,
      selectedCategory: {},
      toleranceResult: {},
      notams: [],
      connectedActions: [],
      signData: {},
      opsLogTags: [],
      validatedMileage: false
    };

    this.processInspectionForState = this.processInspectionForState.bind(this);
    this.handleGoToChecklist = this.handleGoToChecklist.bind(this);
    this.handleGoInspections = this.handleGoInspections.bind(this);
    this.handleAnswerChanged = this.handleAnswerChanged.bind(this);
    this.handleFieldErrorChanged = this.handleFieldErrorChanged.bind(this);
    this.handleSubminInspection = this.handleSubminInspection.bind(this);
    this.handleInspectionItemAnswerChanged = this.handleInspectionItemAnswerChanged.bind(
      this
    );
    this.handleInspectionColumnAnswerChanged = this.handleInspectionColumnAnswerChanged.bind(
      this
    );
    this.handleInspectionItemRemarkChanged = this.handleInspectionItemRemarkChanged.bind(
      this
    );
    this.handleInspectionFieldChanged = this.handleInspectionFieldChanged.bind(
      this
    );

    this.isChecklistComplete = this.isChecklistComplete.bind(this);
    this.handleGoBackToDetails = this.handleGoBackToDetails.bind(this);
    this.handleCompleteInspection = this.handleCompleteInspection.bind(this);
    this.isUnsatisfactory = this.isUnsatisfactory.bind(this);
    this.handleItemToleranceResultChange = this.handleItemToleranceResultChange.bind(this);

    this.images = importAllImages(
      require.context(
        '../../../icons/inspection-icons',
        false,
        /\.(png|jpe?g|svg)$/
      )
    );
    this.URL_ROUTE = INSPECTIONS;
    if (props?.match?.url?.includes('/arff')) {
      this.URL_ROUTE = '/arff/inspections/';
    }
    if (props.match?.url?.includes('/sms')) {
      this.URL_ROUTE = '/sms/inspections/';
    }
  }

  async componentDidMount() {
    const {
      actionFetch,
      actionFetchDraft,
      match,
      shiftTypes,
      allDataSources,
      actionFetchShiftTypes,
      flowInspId,
      actionFetchChecklistAttachments,
      fetchDataSources
    } = this.props;
    const id = match?.params?.id || flowInspId;
    await actionFetch(id);
    actionFetchDraft(id);
    if (!allDataSources?.length) {
      fetchDataSources();
    }
    if (!shiftTypes.length) await actionFetchShiftTypes();
    this.setState({
      draftLoading: true
    });
    actionFetchChecklistAttachments(id);
  }

  async componentDidUpdate(prevProps) {
    const {
      inspection,
      draftdata,
      opslog_tags,
      fetchDraftInspectionAction
    } = this.props;

    const { answers, fieldErrors, opsLogTags } = this.state;
    if (opslog_tags && opsLogTags?.length===0 && answers?.tags?.length===0
      && !(answers?.tags?.length===opslog_tags.filter(e => !e?.status)?.length)) {
      this.updateTags(opslog_tags.filter(e => !e?.status), answers?.tags||[]);
    }
    if (!prevProps.inspection.id && inspection.id) {
      this.processInspectionForState(inspection);
    }
    if (
      prevProps?.fetchDraftInspectionAction?.loading === true
      && !fetchDraftInspectionAction?.loading
    ) {
      this.setState({ draftLoading: fetchDraftInspectionAction.loading });
    }

    if (JSON.stringify(prevProps.draftdata) !== JSON.stringify(draftdata)) {
      let draftFieldErrors = fieldErrors;
      if (draftdata.response) {
        Object.keys(draftdata.response).forEach((eachKey) => {
          if (draftdata.response?.[eachKey]?.length > 0 && draftFieldErrors?.[eachKey]) {
            draftFieldErrors[eachKey] = false;
          }
        });
      }
      this.setState({
        answers: {
          ...draftdata.response,
          ...answers
        },
        fieldErrors: {
          ...draftFieldErrors
        }
      });
    }
  }

  componentWillUnmount() {
    const { actionClear } = this.props;
    actionClear();
    this.setState({ signData: {} });
  }

  static getDerivedStateFromProps(props, state) {
    // grab user from state
    if (props.user.id && !state.answers.inspected_by) {
      return {
        ...state,
        answers: {
          ...state.answers,
          inspected_by: {
            id: props.user.id,
            fullname: props.user.fullname
          }
        },
        shiftSetting: props.user?.portal_airport?.airport_settings?.inspection_shift
      };
    }
    // update state when answer is completed.
    if (
      props.createAction
      && props.answerCreated
      && props.answerCreated.status === 1
    ) {
      if (props.flowFieldId) {
        props.handleFlowField(props.draftdata.id, props.flowFieldId);
      } else {
        return { ...state, apiStatus: props.createAction.success };
      }
    }

    if (props.draftdata && Object.keys(props.draftdata).length && state.remarks.length === 0) {
      let allNotams = state.notams;
      let allConnectedActions = state.connectedActions;
      if (allNotams?.length === 0 && props?.draftdata?.notams?.length > 0) {
        allNotams = props.draftdata?.notams?.map(notam => ({ ...notam, notams: { [notam?.notams?.notam_id]: notam?.notams } }));
      }
      if (allConnectedActions?.length === 0 && props?.draftdata?.connected_actions?.length > 0) {
        allConnectedActions = props?.draftdata?.connected_actions;
      }
      return {
        ...state,
        remarks: props.draftdata.remarks,
        notams: allNotams,
        connectedActions: allConnectedActions
      };
    }

    // update remarks IDs when a new remark is created;
    const r = props.remarkCreated;
    if (r?.id) {
      const thestate = state;
      const notExist = thestate.remarks?.filter(rem => rem?.id === r?.id);
      const remainingRemarks = thestate.remarks?.filter(rem => rem?.id !== r?.id);
      if (notExist?.length === 0) {
        thestate.remarks.push(r);
      } else if (remainingRemarks?.length !== thestate?.remarks?.length) {
        thestate.remarks = [
          ...remainingRemarks,
          r
        ];
      }
      return thestate;
    }

    return state;
  }

  getFileNames = async count => await GetFileName.getUploadFileName(count);

  doS3Upload = async (files, fileIds, entity) => await S3Uploads.uploadFiles(
    files,
    fileIds.filename,
    entity
  );

  showFormErrorsModal = () => {
    const { actionConfirm, actionHideModal } = this.props;
    const content = {
      title: '',
      body: (
        <div className={styles.submissionError}>
          <FormattedMessage
            id="inspections.complete_inspections.incomplete_checklist"
            defaultMessage="There was a problem with your submission. Please make sure you've answered all of the inspection checklists."
          />
        </div>
      )
    };
    actionConfirm(
      content,
      () => {
        actionHideModal();
      },
      actionHideModal
    );
  };

  handleWorkorderCreate = (newWorkOrder) => {
    const { open_workorders } = this.state;
    if (!open_workorders.length) {
      this.setState(prevState => ({
        inspection: {
          ...prevState.inspection,
          workorders: [...prevState.inspection.workorders, newWorkOrder]
        }
      }));
    } else {
      this.setState(prevState => ({
        open_workorders: [...prevState.open_workorders, newWorkOrder]
      }));
    }
  };

  // eslint-disable-next-line react/sort-comp
  processInspectionForState(inspection) {
    if (inspection) {
      const { details } = inspection;
      let requiredMap = {};
      let fieldErrors = {};
      let lastFieldErrors = {};
      let checklistFieldErrors = {};
      const attachmentFields = [];
      const conditionalFields = {};
      details.fields.forEach((detailField) => {
        requiredMap = {
          ...requiredMap,
          [detailField.id]: detailField.required
        };
        if (detailField?.display_separately === true) {
          lastFieldErrors = {
            ...lastFieldErrors,
            [detailField.id]: detailField.required
          };
        } else if (detailField?.display_with_checklist === true) {
          checklistFieldErrors = {
            ...checklistFieldErrors,
            [detailField.id]: detailField.required
          };
        } else if (!detailField.conditional) {
          fieldErrors = {
            ...fieldErrors,
            [detailField.id]: detailField.required
          };
        } else {
          conditionalFields[
            detailField?.conditional_field?.key
          ] = detailField;
        }
        if (detailField.type === 'dataSource' && (detailField?.dataSourceID === 'ds3' || detailField?.dataSourceID === 'ds4')) {
          fieldErrors = {
            ...fieldErrors,
            [detailField.id]: false
          };
        }
        if (detailField.type === 'attachments') {
          attachmentFields.push(detailField.id);
        }
      });

      fieldErrors.date = false;
      fieldErrors.inspected_by = false;
      this.setState({
        inspection,
        requiredMap,
        fieldErrors,
        lastFieldErrors,
        attachmentFields,
        checklistFieldErrors,
        conditionalFields
      });
    }
  }

  filterSpecificChecklist = (checklist) => {
    const { selectedCategory } = this.state;
    const selectedChecklist = [];
    checklist.forEach((category) => {
      const selectedItems = category?.checklist?.filter(item => selectedCategory?.[category?.id]?.[item?.key] === true);
      if (selectedItems?.length > 0) {
        selectedChecklist.push({
          ...category,
          checklist: selectedItems
        });
      }
    });

    return selectedChecklist;
  }

  handleGoToChecklist() {
    const {
      fieldErrors,
      answers,
      selectedCategory,
      validatedMileage
    } = this.state;
    const { inspection } = this.props;
    const noErrors = (validatedMileage === false) && fieldErrors && Object.keys(fieldErrors).every(k => (answers[k]
        && inspection.details.fields.map(l => l.type === 'string') === true
        && answers[k].trim() !== ' '
      ? true
      : fieldErrors[k] === false));
    if (noErrors) {
      let date1 = new Date(answers?.date);
      let date2 = new Date(answers?.date);
      date1.setHours(0, 0, 0, 0);
      date2.setHours(23, 59, 59, 999);

      this.setState({ stage: 2 });
      const response = {};
      const ids = {};
      let flag = true;
      if (inspection.checklist) {
        inspection.checklist.forEach((inspectionField, idx) => {
        ids[inspectionField.id] = idx;
        const checklist_length = Object.keys(
          inspectionField.checklist.filter(
            item => checkChecklistCondition(item, answers)
          )
        ).length;
        if (checklist_length > 0 && flag) {
          this.setState({ activeInspectionField: idx });
          flag = false;
        }
        });
      }
      Object.keys(answers).forEach((FieldId) => {
        if (FieldId in ids) {
          const checklist_length = Object.keys(
            inspection.checklist[ids[FieldId]].checklist.filter(
              item => checkChecklistCondition(item, answers)
            )
          ).length;
          if (checklist_length > 0) {
            const item_list = {};
            inspection.checklist[ids[FieldId]].checklist.forEach((item) => {
              if (checkChecklistCondition(item, answers)) {
                if (item.key in answers[FieldId]) item_list[item.key] = answers[FieldId][item.key];
              }
            });
            if (Object.keys(item_list).length > 0) response[FieldId] = item_list;
          }
        } else {
          response[FieldId] = answers[FieldId];
        }
      });
      if (inspection?.supplement_inspection && selectedCategory && Object.keys(selectedCategory)?.length > 0) {
        const selectedChecklist = this.filterSpecificChecklist(inspection?.checklist);
        if (selectedChecklist?.length > 0) {
          this.setState({ inspection: { ...inspection, checklist: selectedChecklist } });
        }
      }
      this.setState({ answers: { ...response } });
    } else {
      this.setState({ showFormErrors: true });
    }
  }

  handleGoInspections() {
    const { history, flowInspId, handleFlowField, location } = this.props;
    if (flowInspId) {
      handleFlowField();
    } else if (location?.state?.nextURL) {
      history.push(location.state?.nextURL);
    } else {
      history.push(this.URL_ROUTE);
    }
  }

  handleAnswerChanged(answer, fieldId) {
    const { inspection: { details: { fields } }, mileageValue } = this.state;

    if (fieldId === 'mileage') {
      if (Number(mileageValue?.mileage) > Number(answer)) {
        this.setState({ validatedMileage: true });
      } else {
        this.setState({ validatedMileage: false });
      }
    }

    if (fields?.[0]?.dataSourceID === 'ds3' && fields?.[0]?.id === fieldId) {
      this.setState(prevState => ({
        answers: {
          ...prevState.answers,
          mileage: undefined,
          usage: undefined
        }
      }));
      }

    if (fieldId === 'date') {
      this.setState({ DateChanged: true });
    }
    const { conditionalFields } = this.state;
    if (conditionalFields?.[fieldId]) {
      const conditionValues = conditionalFields[fieldId]?.conditional_values;
      let fieldValue = answer;
      if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
      const enabelCondition = conditionValues.filter(
        value => fieldValue.includes(value?.value) === true
      ).length > 0;
      if (conditionalFields?.[fieldId].required) {
        this.handleFieldErrorChanged(
          conditionalFields[fieldId].id,
          enabelCondition
        );
      }
      this.setState(prevState => ({
        answers: {
          ...prevState.answers,
          [fieldId]: answer,
          [conditionalFields[fieldId].id]: ''
        }
      }));
    } else if (fieldId === 'tags') {
      const { opsLogTags } = this.state;
      let updatedOpsLogTags = opsLogTags.filter(e => e?.id!==answer?.id);
      this.setState(prevState => ({
        opsLogTags: updatedOpsLogTags,
        answers: {
          ...prevState.answers,
          [fieldId]: [...prevState?.answers[fieldId], answer]
        }
      }));
    } else {
      this.setState(prevState => ({
        answers: {
          ...prevState.answers,
          [fieldId]: answer
        }
      }));
    }
  }

  handleFieldErrorChanged(fieldId, errorValue) {
    const { lastFieldErrors, checklistFieldErrors } = this.state;
    if (lastFieldErrors !== undefined) {
      if (fieldId in lastFieldErrors) {
        this.setState(prevState => ({
          ...prevState,
          lastFieldErrors: {
            ...prevState.lastFieldErrors,
            [fieldId]: errorValue
          }
        }));
      } else if (fieldId in checklistFieldErrors) {
        this.setState(prevState => ({
          ...prevState,
          checklistFieldErrors: {
            ...prevState.checklistFieldErrors,
            [fieldId]: errorValue
          }
        }));
      } else {
        this.setState(prevState => ({
          ...prevState,
          fieldErrors: {
            ...prevState.fieldErrors,
            [fieldId]: errorValue
          }
        }));
      }
    }
  }

  handleInspectionItemAnswerChanged(inspectionFieldId, itemKey, value) {
    this.setState(prevState => ({
      answers: {
        ...prevState.answers,
        [inspectionFieldId]: {
          ...prevState.answers[inspectionFieldId],
          [itemKey]: value
        }
      },
      incompleteChecklist: false
    }));
  }

  handleItemToleranceResultChange(inspectionFieldId, itemKey, value) {
    this.setState(prevState => ({
      toleranceResult: {
        ...prevState.toleranceResult,
        [inspectionFieldId]: {
          ...prevState.toleranceResult[inspectionFieldId],
          [itemKey]: value
        }
      }
    }));
  }

  handleInspectionColumnAnswerChanged(
    inspectionFieldId,
    checkKey,
    itemKey,
    value
  ) {
    this.setState(prevState => ({
      answers: {
        ...prevState.answers,
        [inspectionFieldId]: {
          ...prevState.answers[inspectionFieldId],
          [checkKey]: {
            ...{ ...prevState.answers[inspectionFieldId] }[checkKey],
            [itemKey]: value
          }
        }
      },
      incompleteChecklist: false
    }));
  }

  handleColumnToleranceResultChange = (
    inspectionFieldId,
    itemKey,
    columnId,
    value
  ) => {
    this.setState(prevState => ({
      toleranceResult: {
        ...prevState.toleranceResult,
        [inspectionFieldId]: {
          ...prevState.toleranceResult[inspectionFieldId],
          [itemKey]: {
            ...{ ...prevState.toleranceResult[inspectionFieldId] }[itemKey],
            [columnId]: value
          }
        }
      }
    }));
  }

  async handleInspectionItemRemarkChanged(inspectionFieldId, itemKey, value) {
    const { answers: { remarks_removed }, answers, remarks } = this.state;
    const { inspection, actionRemoveRemark, actionDeleteRemark } = this.props;
    if (value?.action === 'delete' && inspection?.remarks_carry_over && value?.carry_over && value?.id) {
      actionRemoveRemark(value?.id);
      const existRemoved = remarks_removed ? [...remarks_removed, value?.id] : [value?.id];
      this.handleAnswerChanged(existRemoved, 'remarks_removed');
      const remainingRemarks = remarks.filter(rem => rem?.id !== value?.id);
      this.setState({ remarks: [...remainingRemarks] });
    } else if (value?.action === 'delete' && value?.id) {
      actionDeleteRemark(value?.id);
      const remainingRemarks = remarks.filter(rem => rem?.id !== value?.id);
      this.setState({ remarks: [...remainingRemarks] });
    } else {
      const { actionCreateRemark, actionEditRemark, draftdata } = this.props;
      const formData = new FormData();
      formData.append('answer', draftdata.id);
      formData.append('field_reference', inspectionFieldId);
      formData.append('item_reference', itemKey);
      formData.append('text', value.text);
      if (value?.location?.coordinates) {
        formData.append('location', JSON.stringify(value?.location));
      }
      let fileIds = '';
      const newAttachments = [];
      let allAttachments = [];
      if (value.attachments && value.attachments.length > 0) {
        allAttachments = value.attachments;
        allAttachments.forEach((e) => {
          if (!e.id) {
            newAttachments.push(e);
          } else {
            formData.append('attachments', e.id);
          }
        });
      }
      if (newAttachments && newAttachments.length > 0) {
        fileIds = await this.getFileNames(newAttachments.length);
      }

      if (fileIds) {
        await this.doS3Upload(newAttachments, fileIds, 'remark').then(() => {
          fileIds.filename.forEach((fileId) => {
            formData.append('attachments', fileId.toString());
          });
        });
      }
      if (
        value?.id
        && value?.carry_over
        && inspection?.remarks_carry_over
      ) {
        actionRemoveRemark(value?.id);
        const existRemoved = remarks_removed ? [...remarks_removed, value?.id] : [value?.id];
        this.handleAnswerChanged(existRemoved, 'remarks_removed');
        const remainingRemarks = remarks.filter(rem => rem?.id !== value?.id);
        this.setState({ remarks: [...remainingRemarks] });
        actionCreateRemark(formData);
      } else if (value?.id) {
        actionEditRemark(value?.id, formData);
      } else {
        const info = {
          created_date: new Date(),
          status: answers?.[inspectionFieldId]?.[itemKey]
        };
        formData.append('info', JSON.stringify(info));
        actionCreateRemark(formData);
      }
    }
  }

  handleInspectionFieldChanged(idx) {
    const {
      answers,
      inspection: { checklist, workorders },
      open_workorders,
      activeInspectionField,
      remarks,
      connectedActions
    } = this.state;
    const {
      nonAirfieldWorkorders,
      inspection,
      airfieldWorkorders
    } = this.props;
    let noError = false;
    requestAnimationFrame(() => {
      const container = document.querySelector('.app-container.menu-toggle');
      if (container) {
        container.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
    const work_orders = !open_workorders.length ? workorders : open_workorders;
    if (inspection.columns !== undefined && inspection.columns.length > 0) {
      const columnField = [];
      const fieldRemarks = remarks?.filter(rem => (
        rem?.field_reference === checklist[activeInspectionField].id
      ));
      if (answers[checklist[activeInspectionField].id]) {
      Object.keys(answers[checklist[activeInspectionField].id]).forEach((f) => {
        const answerVal = answers[checklist[activeInspectionField].id][f];
        if (
          answerVal && typeof answerVal === 'object'
          && Object.values(answerVal).includes(false)
        ) {
          columnField.push(f);
        }
      });
      }
      if (fieldRemarks.length > 0) {
      if (answers[checklist[activeInspectionField].id]) {
        Object.keys(answers[checklist[activeInspectionField].id]).forEach(
          () => {
            let isError = false;
            columnField.forEach((item) => {
              if (
                fieldRemarks?.filter(rem => rem?.item_reference === item)?.length === 0
              ) {
                isError = true;
              }
              return item;
            });
            if (isError) {
              noError = true;
              this.setState({ unsatisfactoryError: true });
            }
          }
        );
        }
      } else if (answers[checklist[activeInspectionField].id]) {
        Object.values(answers[checklist[activeInspectionField].id]).forEach(
          (f) => {
            if (f && typeof f === 'object' && Object.values(f).includes(false)) {
              noError = true;
            }
          }
        );
      }
    } else if (answers[checklist[activeInspectionField].id]) {
      Object.keys(answers[checklist[activeInspectionField].id]).forEach((key) => {
        if (!answers[checklist[activeInspectionField].id][key]) {
          let wo = [];
          let nwo = [];
          let awo = [];
          let actions = [];
          let remarksList = [];
          if (work_orders) {
            wo = work_orders.filter(
              e => checklist[activeInspectionField].id === e.category_id
                && key === e.subcategory_id
            );
          }
          if (
            nonAirfieldWorkorders !== undefined
            && nonAirfieldWorkorders.length
          ) {
            nwo = nonAirfieldWorkorders.filter(
              w => checklist[activeInspectionField].id === w.category_id
                && key === w.subcategory_id
            );
          }
          if (airfieldWorkorders && airfieldWorkorders.length) {
            awo = airfieldWorkorders.filter(
              k => checklist[activeInspectionField].id === k.category_id
                && key === k.subcategory_id
            );
          }
          if (connectedActions && connectedActions?.length) {
            actions = connectedActions.filter(
              action => (
                checklist[activeInspectionField].id === action.field_reference
                && key === action.item_reference
              )
            );
          }
          if (remarks && remarks?.length) {
            remarksList = remarks.filter(rem => (
              checklist[activeInspectionField].id === rem.field_reference
              && key === rem.item_reference
            ));
          }
          if (
            remarksList?.length > 0
            || wo.length > 0
            || nwo.length > 0
            || awo.length > 0
            || actions.length > 0
          ) {
            this.setState({ unsatisfactoryError: false });
          } else {
            noError = true;
            this.setState({ unsatisfactoryError: true });
          }
        }
      });
    }
    if (!noError) {
      this.setState({
        activeInspectionField: idx,
        incompleteChecklist: false
      });
    } else {
      this.setState({ unsatisfactoryError: true });
    }
  }

  handleGoBackToDetails() {
    this.setState({ stage: 1 });
  }

  isChecklistComplete() {
    const {
      answers,
      inspection: { checklist }
    } = this.state;
    const allAnswered = checklist.reduce((accumulator, currentItem) => {
      const checklist_length = Object.keys(
        currentItem.checklist.filter(
          item => checkChecklistCondition(item, answers)
        )
      ).length;
      if (checklist_length > 0) {
        const currentAnswers = answers[currentItem.id];
        const hasAllItemsAnswered = currentAnswers
          && checklist_length > 0
          && checklist_length === Object.keys(currentAnswers).length;
        if (!hasAllItemsAnswered) {
          return false;
        }
        const currentColumns = currentItem?.columns || [];
        if (currentColumns.length > 0) {
          const allColumnsAnswered = Object.values(currentAnswers).every(answerValue => (
            currentColumns.every(column => (
              answerValue !== undefined
              && answerValue !== null
              && Object.prototype.hasOwnProperty.call(answerValue, column.key)
              && answerValue[column.key] !== undefined
            ))
          ));
          return !!accumulator && !!allColumnsAnswered;
        }
        return !!accumulator;
      }
      return true;
    }, true);
    return allAnswered;
  }

  checkValidTags = (data) => {
    if (data !== undefined && data?.length > 0) {
      let validatedTags = [];
      data.forEach((tag) => {
        let tagsArray = [];
        if (typeof tag === 'string') {
          tagsArray.push(tag);
        } else if (Array.isArray(tag)) {
          tag.forEach((t) => {
            if (typeof t === 'string') {
              tagsArray.push(t);
            }
          });
        }
        if (tagsArray.length > 0) {
          validatedTags.push(tagsArray);
        }
      });
      return validatedTags;
    }
    return [];
  };

  hasUnsatisfactoryResolution(fieldId, itemKey, work_orders) {
    const {
      remarks,
      connectedActions
    } = this.state;
    const { nonAirfieldWorkorders, airfieldWorkorders } = this.props;

    let wo = [];
    let nwo = [];
    let awo = [];
    let actions = [];
    let remarksList = [];

    if (work_orders) {
      wo = work_orders.filter(
        workOrder => fieldId === workOrder.category_id
          && itemKey === workOrder.subcategory_id
      );
    }
    if (
      nonAirfieldWorkorders !== undefined
      && nonAirfieldWorkorders.length
    ) {
      nwo = nonAirfieldWorkorders.filter(
        workOrder => fieldId === workOrder.category_id
          && itemKey === workOrder.subcategory_id
          && Array.isArray(workOrder.order_numbers)
          && workOrder.order_numbers.length > 0
      );
    }
    if (
      airfieldWorkorders !== undefined
      && airfieldWorkorders.length
    ) {
      awo = airfieldWorkorders.filter(
        workOrder => fieldId === workOrder.category_id
          && itemKey === workOrder.subcategory_id
          && Array.isArray(workOrder.order_numbers)
          && workOrder.order_numbers.length > 0
      );
    }
    if (connectedActions && connectedActions?.length) {
      actions = connectedActions.filter(
        action => (
          fieldId === action.field_reference
          && itemKey === action.item_reference
        )
      );
    }
    if (remarks && remarks?.length) {
      remarksList = remarks.filter(
        remark => (
          fieldId === remark.field_reference
          && itemKey === remark.item_reference
      )
    );
    }

    return (
      remarksList?.length > 0
      || wo.length > 0
      || nwo.length > 0
      || awo.length > 0
      || actions.length > 0
    );
  }

  isUnsatisfactory() {
    const {
      answers,
      inspection: { checklist, workorders, columns },
      open_workorders
    } = this.state;
    let noError = false;
    const work_orders = !open_workorders.length ? workorders : open_workorders;
    checklist.forEach((item) => {
      const itemAnswers = answers[item.id];
      if (!itemAnswers) {
        return;
      }
      const currentColumns = item?.columns?.length > 0 ? item.columns : columns;
      Object.keys(itemAnswers).forEach((key) => {
        const itemValue = itemAnswers[key];
        const hasUnsatisfactoryValue = currentColumns !== undefined && currentColumns.length > 0
          ? currentColumns.some(column => itemValue?.[column.key] === false)
          : itemValue === false;
        if (hasUnsatisfactoryValue
          && !this.hasUnsatisfactoryResolution(item.id, key, work_orders)) {
          noError = true;
        }
      });
    });
    return noError;
  }

  handleCompleteInspection() {
    const { answers, checklistFieldErrors } = this.state;
    this.setState({ incompleteChecklist: false, unsatisfactoryError: false });
    const noErrors = checklistFieldErrors ? (Object.keys(checklistFieldErrors)?.every(k => checklistFieldErrors[k] === false)):(true);
    if (noErrors) {
      const isChecklistError = this.isChecklistComplete();
      let isUnsatisfactoryError = false;
      if (isChecklistError) isUnsatisfactoryError = this.isUnsatisfactory();
      if (isChecklistError && !isUnsatisfactoryError) {
        this.setState({ showStartEndModel: true });
      }
      if (!isChecklistError) this.setState({ showErrorModal: true, loadingStatus: false });
      if (isUnsatisfactoryError) this.setState({ unsatisfactoryError: true, loadingStatus: false });
      this.setState({ showFormErrors: false, answers: { ...answers, start_date: moment(answers.date).format(), end_date: moment().format() } });
    } else {
      this.setState({ showFormErrors: true });
    }
  }

  async handleSubminInspection() {
    const {
      answers: {
        date,
        type,
        start_date,
        end_date,
        inspected_by,
        shiftName,
        taskDetails,
        remarks_removed,
        mileage,
        usage,
        ...rest
      },
      answers,
      lastFieldErrors,
      toleranceResult,
      attachmentFields
    } = this.state;

    this.setState({ incompleteChecklist: false, loadingStatus: true });
    const {
      actionSubmit,
      match,
      draftdata,
      location,
      inspection,
      flowInspId
    } = this.props;
    const id = match?.params?.id || flowInspId;

    const noErrors = lastFieldErrors && Object.keys(lastFieldErrors).every(k => (answers[k]
        && inspection.details.fields.map(l => l.type === 'string') === true
        && answers[k].trim() !== ' '
      ? true
      : lastFieldErrors[k] === false));
      if (moment(start_date).format() >= moment(end_date).format()) {
      this.setState({ loadingStatus: false, showDateerror: true });
      return;
    }

    if (noErrors) {
      let response = rest;
      if (inspection?.tolerance_inspection) {
        response = { ...rest, tolerance_result: toleranceResult };
      }
      const selectedChecklist = this.filterSpecificChecklist(inspection?.checklist);
      let task_details = location?.state?.taskid ? location.state : {};
      if (taskDetails && Object.keys(taskDetails)?.length > 0) {
        task_details = { ...taskDetails };
      }
      const signFields = inspection.details.fields.filter(item => item.type === 'signature');
      if (signFields.length > 0) {
        for (let index = 0; index < signFields.length; index++) {
          const signatureData = response[signFields[index].id];
          if (signatureData) {
            let fileIds = '';
            fileIds = await this.getFileNames(1);
            if (fileIds) {
              await this.doS3Upload(
                [signatureData],
                fileIds,
                'inspection_signature'
              );
              response[signFields[index].id] = [fileIds.filename.toString()];
            }
          }
        }
      }
      const tagData = [];
      let newUsage = '';
      Object.keys(answers).forEach((k) => {
        if (k === 'tags' && answers[k] !== null && answers[k] !== undefined) {
          answers[k].forEach(tag => tagData.push(tag?.name));
          answers.tags = tagData;
        }
        if (k === 'usage') {
          let usage_value = answers[k];
          // eslint-disable-next-line no-useless-escape
          if (usage_value?.match(/^(\d*\:{0,1}\d{0,2}$)/)) {
            let decimalTime = usage_value?.split(':');
              let hrs = +decimalTime[0];
              let min = +decimalTime[1];
            newUsage = `${String(hrs || 0).padStart(2, '0')}.${String(min || 0).padStart(2, '0')}`;
          } else if (usage_value?.match(/^(\d*\.{0,1}\d{0,2}$)/)) {
            let newValue = usage_value;
            let hrs = Math.floor(newValue);
            let min = Math.round((newValue % 1) * 60);
            newUsage = `${String(hrs || 0).padStart(2, '0')}.${String(min || 0).padStart(2, '0')}`;
          }
        }
      });
      if (attachmentFields.length > 0) {
        for (let attachment_index = 0; attachment_index < attachmentFields.length; attachment_index++) {
          const attachmentField = attachmentFields[attachment_index];
          if (response?.[attachmentField]) {
            let fileIds = '';
            const attachments = [];
            if (response[attachmentField]?.length > 0) {
              fileIds = await this.getFileNames(
                response[attachmentField].length
              );
            }
            if (fileIds) {
              await this.doS3Upload(
                response[attachmentField],
                fileIds,
                'inspection_attachments'
              ).then(() => {
                fileIds.filename.forEach((fieldId) => {
                  attachments.push(fieldId.toString());
                });
              });
            }
            response[attachmentField] = attachments;
          }
        }
      }
      let condition_ratingVal = [];
      if (answers?.condition_rating && Object.values(answers?.condition_rating)?.length > 0) {
        condition_ratingVal = answers?.condition_rating?.split(' - ');
      }
      let rating;
      if (condition_ratingVal?.length > 0) {
        rating = Number(condition_ratingVal[0]);
      }
      actionSubmit(id, {
        answer_id: draftdata.id,
        response,
        date: new Date(date),
        start_date: moment(start_date).format(),
        end_date: moment(end_date).format(),
        email_inspection_date: moment().format('YYYY-MM-DD HH:mm'),
        weather: {},
        inspected_by: inspected_by.id,
        created_by: inspected_by.id,
        task_details,
        mileage,
        usage: newUsage,
        tags: answers?.tags,
        condition_rating: answers?.condition_rating,
        rating,
        shift_name: shiftName,
        email_date: moment().format(),
        start_time: moment(start_date).format(
          'hh:mm a'
        ),
        end_time: moment(new Date(end_date)).format(
          'hh:mm a'
        ),
        selected_checklist: selectedChecklist,
        remarks_removed,
        location_index: location?.state?.globalLocations
      });
    } else {
      this.setState({ loadingStatus: false, showFormErrors: true });
    }
  }

  handleSelectedCategories = (category, item) => {
    const { selectedCategory } = this.state;
    const { inspection } = this.props;
    if (item === 'all') {
      const checklistValues = inspection.checklist?.filter(field => (
        field?.id === category?.id
      ))?.[0]?.checklist || [];
      selectedCategory[category?.id] = selectedCategory?.[category?.id] || {};
      const existSelected = Object.keys(selectedCategory?.[category?.id]).filter(
        k => (selectedCategory?.[category?.id][k] === true)
      )?.length > 0;
      checklistValues.forEach((val) => {
        selectedCategory[category?.id] = {
          ...selectedCategory[category?.id],
          [val.key]: !existSelected
        };
      });
    } else {
      selectedCategory[category?.id] = selectedCategory?.[category?.id] || {};
      selectedCategory[category?.id] = {
        ...selectedCategory[category?.id],
        [item.key]: !selectedCategory[category?.id]?.[item.key]
      };
    }
    this.setState({
      selectedCategory
    });
  }

  handleAddNotams = (selectedNotams) => {
    const { notams } = this.state;
    if (selectedNotams) {
      this.setState({ notams: [...notams, selectedNotams] });
    }
  }

  handleSignData = (fieldId, data) => {
    const { signData } = this.state;
    this.setState({ signData: { ...signData, [fieldId]: data } });
  }

  updateTags = (allTags, tags) => {
    let updatedData = [];
    if (allTags && tags?.length===0) {
      updatedData = allTags?.map(e => ({ id: e?.name, name: e?.name }));
    } else {
      updatedData = allTags?.filter(value => tags?.find(i => i?.name === value?.name)?.name !== value?.name);
    }
    this.setState({ opsLogTags: updatedData });
  };

  handleRemoveTag = (tag) => {
    const { answers } = this.state;
    const updatedOpsLogTags = answers?.tags?.filter(e => e?.id!==tag?.id);
    this.setState(prev => ({ ...prev, opsLogTags: [...prev?.opsLogTags, tag], answers: { ...answers, 'tags': updatedOpsLogTags } }));
  };

  render() {
    const {
      stage,
      answers,
      requiredMap,
      showFormErrors,
      apiStatus,
      incompleteChecklist,
      inspection: { info, details, checklist },
      activeInspectionField,
      remarks,
      showModal,
      showErrorModal,
      loadingStatus,
      showStartEndModel,
      unsatisfactoryError,
      open_workorders,
      draftLoading,
      shiftSetting,
      selectedCategory,
      toleranceResult,
      notams,
      connectedActions,
      signData,
      showDateerror,
      validatedMileage,
      opsLogTags
    } = this.state;

    const {
      userlist,
      inspection,
      user,
      translations,
      draftdata,
      shiftTypes,
      allDataSources,
      airfieldWorkorders,
      workordersSummary,
      nonAirfieldWorkorders,
      allWorkOrders,
      fetchRemarksAction,
      flowInspId,
      location,
      history,
      checklistAttachments,
      inspection_shift_tasks,
      Tags
    } = this.props;
    const translationMap = translations && translations[user.language]
      ? translations[user.language]
      : {};
    const auditTitle = this.URL_ROUTE?.includes('sms');
    let titles = {
      complete: { id: 'inspections.complete_inspections.complete', default: 'Complete Inspection' },
      back_title: { id: 'inspections.start.inspections.back', default: 'Back to Inspections' },
      draft_title: { id: 'inspections.draft_inspection.saved', default: 'Your Inspection has been saved' },
      incomplete_checklist: { id: 'inspections.complete_inspections.incomplete_checklist',
      default: "There was a problem with your submission. Please make sure you've answered all of the inspection checklists." }
    };
    if (this.URL_ROUTE?.includes('sms')) {
      titles = {
        complete: { id: 'safetyAudit.complete_audit.complete', default: 'Complete Audit' },
        back_title: { id: 'safetyAudits.start.audit.back', default: 'Back to Audits' },
        draft_title: { id: 'safetyAudits.draft_audit.saved', default: 'Your Audit has been saved' },
        incomplete_checklist: { id: 'safetyAudits.complete_audit.incomplete_checklist',
         default: "There was a problem with your submission. Please make sure you've answered all of the audit checklists." }
      };
    }
    return (
      <>
        <Loading loadingStatus={draftLoading} />
        <SectionHeader
          icon={
            info.icon.includes('.png')
              ? this.images[info.icon]?.default
              : this.images[`${info.icon}.svg`]?.default
          }
          translationID="invalid"
          defaultTitle={info.title}
          title={info.title}
        >
          {stage === 2 && !apiStatus && (
            <>
              <div className={styles.completeBtn}>
                <Button
                  action="tertiary"
                  onClick={this.handleGoBackToDetails}
                  translationID="inspections.complete_inspections.back_to_details"
                  defaultText="Go back to Details"
                />
              </div>
              <div className={styles.completeBtn}>
                <Button
                  action="secondary"
                  onClick={this.handleCompleteInspection}
                  translationID={titles.complete.id}
                  defaultText={titles.complete.default}
                />
              </div>
              <Modal
                onClose={() => this.setState({ showModal: false })}
                showIn={showModal}
                width="35%"
                minHeight="20%"
              >
                <div className={styles.confirmContent}>
                  <FormattedMessage
                    id={titles.draft_title.id}
                    defaultMessage={titles.draft_title.default}
                  />
                </div>
                <div className={styles.btn}>
                  <Button
                    type="secondary"
                    translationID="inspections.list.ok"
                    onClick={() => this.setState({ showModal: false })}
                    defaultText="OK"
                  />
                </div>
              </Modal>
              <CompletionModal
                handleFieldErrorChanged={this.handleFieldErrorChanged}
                handleAnswerChanged={this.handleAnswerChanged}
                handleSubminInspection={this.handleSubminInspection}
                handleDateChanged={(a, b) => { this.setState({ answers: { ...answers, [b]: a } }); }}
                onClose={() => this.setState({ showStartEndModel: false })}
                details={details}
                answers={answers}
                requiredMap={requiredMap}
                allDataSources={allDataSources}
                showFormErrors={showFormErrors}
                showDateerror={showDateerror}
                showStartEndModel={showStartEndModel}
                shiftTasks={inspection_shift_tasks}
                history={history}
                user={user}
                lastMileageValue={validatedMileage}
                auditTitle={auditTitle}
              />
              {!showErrorModal && <Loading loadingStatus={loadingStatus} />}
              <Modal
                onClose={() => this.setState({ showErrorModal: false })}
                showIn={showErrorModal}
                width="40%"
                minHeight="30%"
              >
                <div className={styles.confirmContent}>
                  <FormattedMessage
                    id={titles.incomplete_checklist.id}
                    defaultMessage={titles.incomplete_checklist.default}
                  />
                </div>
                <div className={styles.btn}>
                  <Button
                    type="secondary"
                    translationID="inspections.list.ok"
                    onClick={() => this.setState({ showErrorModal: false })}
                    defaultText="OK"
                  />
                </div>
              </Modal>
              <Modal
                onClose={() => this.setState({ unsatisfactoryError: false })}
                showIn={unsatisfactoryError}
                width="40%"
                minHeight="30%"
              >
                <div className={styles.confirmContent}>
                  <FormattedMessage
                    id="inspections.complete_inspections.unsatisfactory_error"
                    defaultMessage="Please add a remark or create a Work Order for all Unsatisfactory items"
                  />
                </div>
                <div className={styles.btn}>
                  <Button
                    type="secondary"
                    translationID="inspections.list.ok"
                    onClick={() => this.setState({ unsatisfactoryError: false })
                    }
                    defaultText="OK"
                  />
                </div>
              </Modal>
            </>
          )}
        </SectionHeader>
        {!flowInspId && (
          <HeaderBack
            translationID="form.start.back"
            translationDefault="Back to Inspections"
            backRoute={this.URL_ROUTE}
            myInspections
            backButtonOnClick={stage === 2 && this.handleGoBackToDetails}
          />
        )}
        <div className={styles.container}>
          {stage === 1 && !apiStatus && draftdata.id && allDataSources && (
            <InspectionDetails
              shiftTypes={shiftTypes}
              translations={translationMap}
              handleAnswerChanged={this.handleAnswerChanged}
              detailsForm={details}
              handleGoToChecklist={this.handleGoToChecklist}
              requiredMap={requiredMap}
              handleFieldErrorChanged={this.handleFieldErrorChanged}
              showFormErrors={showFormErrors}
              userlist={userlist}
              allDataSources={allDataSources}
              shiftSetting={shiftSetting}
              categories={inspection?.checklist}
              groups={inspection?.groups}
              handleSelectedCategories={this.handleSelectedCategories}
              selectedCategory={selectedCategory}
              handleGoInspections={this.handleGoInspections}
              supplementInspection={inspection?.supplement_inspection}
              signData={signData}
              handleSignData={this.handleSignData}
              answers={answers}
              historyState={location?.state}
              settings={inspection?.settings}
              opslog_tags={opsLogTags}
              handleRemoveTag={this.handleRemoveTag}
              Tags={this.checkValidTags(Tags)}
              user={user}
              lastMileageValue={validatedMileage}
            />
           )}
          {stage === 2 && !apiStatus
             && (
              <InspectionChecklist
                id={inspection.id}
                answers={answers}
                toleranceResult={toleranceResult}
                remarks={remarks}
                details={details}
                handleFieldErrorChanged={this.handleFieldErrorChanged}
                showFormErrors={showFormErrors}
                requiredMap={requiredMap}
                groups={inspection?.groups}
                draftdata={draftdata}
                fetchRemarksAction={fetchRemarksAction}
                translations={translationMap}
                workorders={
                  !open_workorders.length
                    ? inspection.workorders
                    : open_workorders
                }
                selfInspection={
                  user?.airport?.safety_self_inspection === inspection?.id
                }
                handleAnswerChanged={this.handleAnswerChanged}
                checklist={checklist}
                isColumn={
                  inspection.columns !== undefined
                  && inspection.columns.length > 0
                }
                handleWorkorderCreate={this.handleWorkorderCreate}
                activeIdx={activeInspectionField}
                handleChecklistItemStatusChange={
                  this.handleInspectionItemAnswerChanged
                }
                handleColumnItemStatusChange={
                  this.handleInspectionColumnAnswerChanged
                }
                handleChecklistItemRemarkChange={
                  this.handleInspectionItemRemarkChanged
                }
                handleInspectionFieldChanged={this.handleInspectionFieldChanged}
                handleItemToleranceResultChange={this.handleItemToleranceResultChange}
                handleColumnToleranceResultChange={this.handleColumnToleranceResultChange}
                apiStatus={apiStatus}
                incompleteChecklist={incompleteChecklist}
                showFeedBackModal={this.showFormErrorsModal}
                shiftTypes={shiftTypes}
                nonAirfieldWorkorders={
                  nonAirfieldWorkorders
                  && nonAirfieldWorkorders.length >= 0
                  && nonAirfieldWorkorders
                }
                allWorkOrders={allWorkOrders}
                airfieldWorkorders={
                  airfieldWorkorders
                  && airfieldWorkorders.length >= 0
                  && airfieldWorkorders
                }
                workordersSummary={
                  workordersSummary
                  && workordersSummary.length > 0
                  && workordersSummary
                }
                checklistAttachments={checklistAttachments}
                inspection={inspection}
                notams={notams}
                connectedActions={connectedActions}
                handleAddNotams={selected => this.handleAddNotams(selected)}
                workorder_satisfactory={inspection?.workorder_satisfactory || false}
                enableNA={inspection?.settings?.na_option}
              />
          )}
          {apiStatus && (
            <InspectionSubmitted
              icon={info.icon}
              name={info.title}
              handleGoInspections={this.handleGoInspections}
              url={this.URL_ROUTE}
            />
          )}
        </div>
      </>
    );
  }
}

CompleteInspection.propTypes = {
  actionFetch: PropTypes.func.isRequired,
  actionClear: PropTypes.func.isRequired,
  actionFetchDraft: PropTypes.func.isRequired,
  actionCreateRemark: PropTypes.func.isRequired,
  actionEditRemark: PropTypes.func.isRequired,
  actionSubmit: PropTypes.func.isRequired,
  actiondraft: PropTypes.func.isRequired,
  actionSearchUser: PropTypes.func.isRequired,
  match: PropTypes.shape({}).isRequired,
  user: PropTypes.shape({}).isRequired,
  answerCreated: PropTypes.shape({}),
  draft_answer: PropTypes.shape({}),
  inspection: PropTypes.shape({}).isRequired,
  draftdata: PropTypes.shape({}),
  history: PropTypes.shape({}).isRequired,
  userlist: PropTypes.arrayOf(PropTypes.shape({})),
  shiftTypes: PropTypes.arrayOf(PropTypes.shape({}))
};

CompleteInspection.defaultProps = {
  userlist: [],
  answerCreated: {},
  draft_answer: {},
  draftdata: {},
  shiftTypes: {}
};

const mapStateToProps = state => ({
  inspection: state.inspection.inspection,
  createAction: state.inspection.createAction,
  answerCreated: state.inspection.answerCreated,
  remarkCreated: state.inspection.remarkCreated,
  user: state.auth.profile,
  fetchDraftInspectionAction: state.inspection.fetchDraftInspectionAction,
  draftdata: state.inspection.draftdata,
  allDataSources: state.inspection.allDataSources,
  fetchRemarksAction: state.inspection.fetchRemarksAction,
  checklistAttachments: state.inspection.checklistAttachments,
  shiftTypes: state.inspection.shiftTypes
});

const mapDispatchToProps = dispatch => ({
  actionFetch: (id) => {
    dispatch(fetchPortalInspection(id));
  },
  actionFetchDraft: (id) => {
    dispatch(fetchDraftInspection(id));
  },
  actionSubmit: (id, data) => {
    dispatch(completeInspection(id, data));
  },
  actionFetchShiftTypes: () => {
    dispatch(fetchShiftTypes());
  },
  fetchDataSources: () => {
    dispatch(fetchDataSourceList());
  },
  actionCreateRemark: (data) => {
    dispatch(createRemark(data));
  },
  actionEditRemark: (id, data) => {
    dispatch(editRemark(id, data));
  },
  actionDeleteRemark: (remarkId) => {
    dispatch(deleteRemark(remarkId));
  },
  actionRemoveRemark: (remarkId) => {
    dispatch(remove_remark(remarkId));
  },
  actionClear: () => {
    dispatch(clearInspection());
  },
  actionFetchChecklistAttachments: (id) => {
    dispatch(getChecklistAttachments(id));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CompleteInspection);
